import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { RegistroIngSalCodManualComponent } from './registrar-ing-sal-cod-manual.component';



const routes: Routes = [
    {
        path: '', component: RegistroIngSalCodManualComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class RegistroIngSalCodManualRoutingModule { }
